"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _LightButton = _interopRequireDefault(require("../buttons/LightButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DropArea = _styledComponents["default"].div.withConfig({
  displayName: "BrowseFiles__DropArea",
  componentId: "lfxksz-0"
})(["flex:1;margin-right:5px;border-radius:4px;background-color:#f2f3f4;text-align:center;"]);

var DropAreaWrapper = _styledComponents["default"].div.withConfig({
  displayName: "BrowseFiles__DropAreaWrapper",
  componentId: "lfxksz-1"
})(["height:36px;width:100%;margin-bottom:10px;display:flex;"]);

var DropAreaText = _styledComponents["default"].span.withConfig({
  displayName: "BrowseFiles__DropAreaText",
  componentId: "lfxksz-2"
})(["font-size:11px;font-weight:300px;font-style:oblique;color:", ";"], function (props) {
  return props.theme["grey"];
});

var BrowseButton = (0, _styledComponents["default"])(_LightButton["default"]).withConfig({
  displayName: "BrowseFiles__BrowseButton",
  componentId: "lfxksz-3"
})(["float:right;"]);

var BrowseFiles = function BrowseFiles(_ref) {
  var fileTypes = _ref.fileTypes,
      onFileAdd = _ref.onFileAdd;

  var getFileTypes = function getFileTypes() {
    if (Array.isArray(fileTypes)) {
      // Given an array of file types, join them with commas
      return fileTypes.join(", ");
    } else if (typeof fileTypes === "string") {
      // Given a string, just use that as the file type
      return fileTypes;
    } else {
      // By passing null, it will allow all file types
      return null;
    }
  };

  return _react["default"].createElement("div", {
    className: "dropzone"
  }, _react["default"].createElement(_reactDropzone["default"], {
    accept: getFileTypes(),
    onDrop: function onDrop(accepted, rejected) {
      // Call the provided onChange function with the new file(s) added
      onFileAdd(accepted);
    },
    disableClick: true
  }, function (_ref2) {
    var getRootProps = _ref2.getRootProps,
        getInputProps = _ref2.getInputProps,
        open = _ref2.open;
    return _react["default"].createElement("div", getRootProps(), _react["default"].createElement("input", getInputProps()), _react["default"].createElement(DropAreaWrapper, null, _react["default"].createElement(DropArea, null, _react["default"].createElement(DropAreaText, null, "drop files here (or click browse)")), _react["default"].createElement(BrowseButton, {
      onClick: function onClick() {
        return open();
      }
    }, "Browse")));
  }));
};

BrowseFiles.propTypes = {
  fileTypes: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  onFileAdd: _propTypes["default"].func.isRequired
};
BrowseFiles.defaultProps = {
  fileTypes: []
};
var _default = BrowseFiles;
exports["default"] = _default;